<template>
  <view class="time-line">
    <view v-for="(item, index) in logList" :key="index" class="line-item">
      <view class="node-icon"></view>
      <view class="content-box">
        <text class="time">{{ item.createTime || item.time }}</text>
        <text class="event">{{ item.eventTitle || item.event }}</text>
        <text class="user" v-if="item.userName">{{ item.userName }}</text>
      </view>
    </view>
  </view>
</template>

<script>
export default {
  name: 'LogTimeLine',
  props: {
    logList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.time-line {
  padding-left: 20rpx;
  border-left: 2rpx solid #eee;
  margin-left: 10rpx;
}

.line-item {
  position: relative;
  padding-bottom: 30rpx;
}

.node-icon {
  position: absolute;
  left: -32rpx;
  top: 10rpx;
  width: 20rpx;
  height: 20rpx;
  border-radius: 50%;
  background-color: #26A69A;
  border: 4rpx solid #fff;
}

.content-box {
  display: flex;
  flex-direction: column;
}

.time {
  font-size: 24rpx;
  color: #999;
}

.event {
  font-size: 26rpx;
  color: #333;
  margin-top: 4rpx;
}

.user {
  font-size: 24rpx;
  color: #666;
  margin-top: 2rpx;
}
</style>
